import storage from 'didi-store'
import { getBDCountry } from '@/common/utils/i18n'
import { GlobalUserInfoLocalStorageKey } from './constant'
export const BIZ_IDS = {
  FOOD: 10000,
  Abastece: 20000,
  SAAS: 30000,
}

// 是否是外卖业务
export function isFoodBiz(bizId) {
  if (!bizId) {
    const userInfo = storage.get(GlobalUserInfoLocalStorageKey)
    bizId = userInfo?.data?.bizId
  }
  return typeof bizId === 'undefined' || (bizId && bizId === BIZ_IDS.FOOD)
}

// 是否是油站业务
export function isAbasteceBiz(bizId) {
  if (!bizId) {
    const userInfo = storage.get(GlobalUserInfoLocalStorageKey)
    bizId = userInfo?.data?.bizId || ''
  }
  return bizId === BIZ_IDS.Abastece
}

//  是否是SaaS业务
export function isSaaSBiz(bizId) {
  if (!bizId) {
    const userInfo = storage.get(GlobalUserInfoLocalStorageKey)
    bizId = userInfo?.data?.bizId || ''
  }
  return bizId === BIZ_IDS.SAAS
}

export function getBizId() {
  const userInfo = storage.get(GlobalUserInfoLocalStorageKey)
  const bizId = userInfo?.data?.bizId || BIZ_IDS.FOOD
  return bizId
}

// food业务线且是BR 才显示待RTBO
export function showRtboStore() {
  return getBDCountry() === 'BR' && isFoodBiz()
}
